export default __webpack_public_path__ + "static/media/sketch01.dcc23895.png";